import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import {createPortal} from "react-dom";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import LazyAssets from "@/app/utils/assets_widget";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  loading?: boolean;
  ignoreOverlay?: boolean;
  withPadding?: boolean;
  withCloseButton?: boolean;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
                                                   open,
                                                   onClose,
                                                   children,
                                                   loading = false,
                                                   ignoreOverlay = true,
                                                   withPadding = false,
                                                   withCloseButton = false,
                                                 }) => {
  if (!open) return null;
  return createPortal(
    <div className={classNames(styles.bottomSheet, {
      [styles.open]: open,
      [styles.ignoreOverlay]: ignoreOverlay,
    })}>
      {ignoreOverlay && (
        <div className={classNames(styles.blend, {[styles.show]: open})} onClick={onClose}>
          {loading && <CircularProgressIndicator isGreen/>}
        </div>
      )}
      <div className={classNames(styles.sheet, {[styles.withPadding]: withPadding})}>
        {withCloseButton && (
          <div className={styles.closeButton} onClick={onClose}>
            <LazyAssets.Close/>
          </div>
        )}
        {!loading && children}
      </div>
    </div>,
    document.body
  );
};

export default BottomSheet;
